import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const accessToken = document.querySelector("#tokenmapboxsearch")?.value;
mapboxgl.accessToken = accessToken;

// Verifica que haya ubicaciones antes de acceder a ellas
const defaultCenter1 = (window.EventLocations && window.EventLocations.length > 0) 
    ? window.EventLocations[0].coords 
    : [-4.106389, 41.192928];

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v11',
  center: defaultCenter1,
  zoom: 8
});

if (window.EventLocations) {
    // window.EventLocations.forEach(location => {
    //     const marker = new mapboxgl.Marker()
    //         .setLngLat(location.coords)
    //         .addTo(map);

    //     marker.getElement().addEventListener('click', () => {
    //         console.log("sii");
    //         document.querySelector(`#pills-events .js-openEventModal[data-id="${location.id}"]`)?.click();
    //     });
    // });

    window.EventLocations.forEach(location => {
        // Creamos el contenido del popup (puede ser HTML)
        const popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML(`
                <strong>${location.name}</strong><br>
                ${location.description || ''}
            `);

        // Creamos el marcador con el popup
        const marker = new mapboxgl.Marker()
            .setLngLat(location.coords)
            .setPopup(popup) // asociamos el popup al marcador
            .addTo(map);

        // Si quieres seguir haciendo click para activar algo más también
        marker.getElement().addEventListener('click', () => {

            // Mostramos el popup manualmente (opcional, normalmente se muestra automáticamente)
            popup.addTo(map);

            // Disparamos el evento personalizado si existe
            // console.log(`#pills-events .js-openEventModal[data-id="${location.id}"]`);
            //document.querySelector(`#pills-events .js-openEventModal[data-id="${location.id}"]`)?.click();
        });
    });    
}

// Verifica que haya ubicaciones antes de acceder a ellas
const defaultCenter2 = (window.SiteLocations && window.SiteLocations.length > 0) 
    ? window.SiteLocations[0].coords 
    : [-4.106389, 41.192928];

const map2 = new mapboxgl.Map({
  container: 'map2',
  style: 'mapbox://styles/mapbox/streets-v11',
  center: defaultCenter2,
  zoom: 8
});

if (window.SiteLocations) {
    window.SiteLocations.forEach(location => {
        const marker = new mapboxgl.Marker()
            .setLngLat(location.coords)
            .addTo(map2);

        marker.getElement().addEventListener('click', () => {
            document.querySelector(`#pills-places .js-openSiteModal[data-id="${location.id}"]`)?.click();
        });
    });
}
